/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrenlargehint3Inputs */

const en_checkinqrenlargehint3 = /** @type {(inputs: Checkinqrenlargehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to enlarge`)
};

const de_checkinqrenlargehint3 = /** @type {(inputs: Checkinqrenlargehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Vergrößern antippen`)
};

/**
* | output |
* | --- |
* | "Tap to enlarge" |
*
* @param {Checkinqrenlargehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrenlargehint3 = /** @type {((inputs?: Checkinqrenlargehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrenlargehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrenlargehint3(inputs)
	return de_checkinqrenlargehint3(inputs)
});
export { checkinqrenlargehint3 as "checkinQrEnlargeHint" }